import * as React from "react";

import { UitkPriceLockupAlign } from "uitk-react-price-lockup";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { PriceLockupGetRates } from "./PriceLockupGetRates";
import { PriceLockupSingapore } from "./PriceLockupSingapore";
import { PriceLockupDefault } from "./PriceLockupDefaults";
import { useHotelsContext } from "src/components/flexComponents/Hotels/components/HotelsContext";

interface PriceLockupProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

function validatePrice({ formattedPrice, hotelPrice }: Hotel) {
  return formattedPrice && hotelPrice && hotelPrice.value !== "0";
}

const PriceLockup = (props: PriceLockupProps) => {
  const { model, context } = useHotelsContext();
  const isValidPrice = validatePrice(props.hotel);
  const isExpediaSG = context?.site?.id === 14;

  if (!isValidPrice && !model.showGetPriceIfNoPrice) {
    return null;
  }

  if (!isValidPrice && model.showGetPriceIfNoPrice) {
    return <PriceLockupGetRates className={props.className || ""} />;
  }

  if (isExpediaSG) {
    return <PriceLockupSingapore {...props} />;
  }

  return <PriceLockupDefault {...props} />;
};

export default PriceLockup;
